



import React, { useState } from "react";
import { Card, CardHeader, CardTitle, CardContent } from "./Card";
import { Dialog, DialogTitle } from "./DialogBox";
import { MdBorderHorizontal } from "react-icons/md";
import { FaExternalLinkAlt } from "react-icons/fa";

const ApplicationTable = ({ userApplication }) => {
  const [selectedApp, setSelectedApp] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedApp(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "Applied":
      case "Shortlisted":
        return "bg-yellow-100 text-yellow-800";
      case "Interviewed":
        return "bg-purple-100 text-purple-800";
      case "Rejected":
        return "bg-red-100 text-red-800";
      case "Offer":
      case "Accepted":
        return "bg-green-100 text-green-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Filter applications by status, ensuring case-insensitive comparison
  const appliedJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "applied" || app.status?.toLowerCase() === "shortlisted"
  ) || [];
  const scheduledJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "interviewed"
  ) || [];
  const rejectedJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "rejected"
  ) || [];
  const hiredJobs = userApplication?.filter(app => 
    app.status?.toLowerCase() === "offer" || app.status?.toLowerCase() === "accepted"
  ) || [];
 console.log(userApplication, "applications")
  // Common table rendering function
  const renderTable = (applications, title) => (
    <div className="mb-8">
      <h3 className="text-lg font-semibold mb-4">{title}</h3>
      <div className="relative overflow-x-auto rounded-lg border border-gray-200">
        <table className="w-full text-sm text-left">
          <thead className="text-xs uppercase bg-gray-50">
            <tr>
              <th className="px-6 py-3 font-medium text-gray-500">Company</th>
              <th className="px-6 py-3 font-medium text-gray-500">Position</th>
              <th className="px-6 py-3 font-medium text-gray-500">Date Applied</th>
              <th className="px-6 py-3 font-medium text-gray-500">Status</th>
              <th className="px-6 py-3 font-medium text-gray-500">Reason</th>
              <th className="px-6 py-3 font-medium text-gray-500 w-[100px]">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {applications?.length > 0 ? (
              applications.map((app, index) => (
                <tr
                  key={index}
                  className="bg-white hover:bg-gray-50 transition-colors"
                >
                  <td className="px-6 py-4">
                    <div>
                      <div className="font-semibold">
                        {app.companyId?.companyName || "N/A"}
                      </div>
                      <div className="text-sm text-gray-500">
                        {app.companyAddress || "N/A"}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">{app.position || "N/A"}</td>
                  <td className="px-6 py-4">
                    {app.createdAt ? new Date(app.createdAt).toLocaleDateString() : "N/A"}
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        app.status
                      )}`}
                    >
                      {app.status || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        app.reasonForRejection
                      )}`}
                    >
                      {app.reasonForRejection || "N/A"}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => {
                        setSelectedApp(app);
                        setIsModalOpen(true);
                      }}
                      className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                    >
                      <MdBorderHorizontal className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="px-6 py-4 text-center text-gray-500">
                  No applications found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle className="text-xl font-semibold">
          Application Records
        </CardTitle>
      </CardHeader>
      <CardContent>
        {renderTable(appliedJobs, "Applied Jobs")}
        {renderTable(scheduledJobs, "Scheduled Jobs (Interviews)")}
        {renderTable(rejectedJobs, "Rejected Jobs")}
        {renderTable(hiredJobs, "Hired Jobs")}

        <Dialog isOpen={isModalOpen} onClose={handleCloseModal}>
          {selectedApp && (
            <>
              <DialogTitle>Application Details</DialogTitle>
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold text-lg">
                    {selectedApp.companyId?.companyName || "N/A"}
                  </h3>
                  <p className="text-gray-500">{selectedApp.companyAddress || "N/A"}</p>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Position</p>
                    <p className="font-medium">{selectedApp.position || "N/A"}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Status</p>
                    <span
                      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(
                        selectedApp.status
                      )}`}
                    >
                      {selectedApp.status || "N/A"}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Date Applied</p>
                    <p className="font-medium">
                      {selectedApp.createdAt ? new Date(selectedApp.createdAt).toLocaleDateString() : "N/A"}
                    </p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Availability</p>
                    <p className="font-medium">{selectedApp.availability || "N/A"}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Open for Students</p>
                    <p className="font-medium">{selectedApp.openForStudents || "N/A"}</p>
                  </div>
                  {selectedApp.dateHired && (
                    <div>
                      <p className="text-sm text-gray-500">Date Hired</p>
                      <p className="font-medium">{selectedApp.dateHired}</p>
                    </div>
                  )}
                  {selectedApp.reasonForRejection && (
                    <div>
                      <p className="text-sm text-gray-500">Reason for Rejection</p>
                      <p className="font-medium">{selectedApp.reasonForRejection}</p>
                    </div>
                  )}
                </div>

                <div>
                  <p className="text-sm text-gray-500">Cover Letter</p>
                  <p className="font-medium">{selectedApp.coverLetter || "N/A"}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Resume</p>
                  <img
                  src={selectedApp.resume || "N/A"}
                  alt="resume-picture"
                   className="font-medium"
                    />
                </div>
                {selectedApp.additionalDocument && (
                  <div>
                    <p className="text-sm text-gray-500">Additional Document</p>
                    <p className="font-medium">{selectedApp.additionalDocument}</p>
                  </div>
                )}
                {selectedApp.additionalQuestionResponse?.length > 0 && (
                  <div>
                    <p className="text-sm text-gray-500">Additional Questions</p>
                    <ul className="list-disc pl-5">
                      {selectedApp.additionalQuestionResponse.map((resp, index) => (
                        <li key={index} className="font-medium">
                          {typeof resp === 'object' && resp !== null ? (
                            <>
                              <span className="font-semibold">Question: </span>{resp.question || "N/A"}
                              <br />
                              <span className="font-semibold">Response: </span>{resp.response || "N/A"}
                            </>
                          ) : (
                            resp
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <button
                  onClick={() =>
                    (window.location.href = `/${selectedApp._id}/applicationStatus`)
                  }
                  className="w-full mt-4 inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaExternalLinkAlt className="w-4 h-4 mr-2" />
                  Track Application
                </button>
              </div>
            </>
          )}
        </Dialog>
      </CardContent>
    </Card>
  );
};

export default ApplicationTable;